import React from "react";
import { TickIcon /*, TickFilledIcon*/ } from "./Icons/TickIcon";

interface CheckBtnProps {
  label: string;
  selected: boolean;
  onChange: (newState: boolean) => void;
  icon?: React.ReactNode;
  labelIcon?: React.ReactNode;
  className?: string;
  size?: "default" | "small" | "large";
  reversed?: boolean;
}

const CheckBtn: React.FC<CheckBtnProps> = ({
  label,
  selected,
  onChange,
  icon,
  labelIcon,
  className = "",
  size = "default",
  reversed = false,
}) => {
  return (
    <div
      className={`check-btn check-btn--${size} ${selected ? "active" : ""} ${reversed ? "check-btn--reversed" : ""} ${className}`}
      onClick={() => onChange(!selected)} 
      role="checkbox"
      aria-checked={selected}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onChange(!selected);
        }
      }}
    >
      <div className="check-btn__ticker">
        {selected && <TickIcon />}
      </div>
      <div className="check-btn__text flex gap-1 items-center">{labelIcon}{label}</div>
    </div>
  );
};

export default CheckBtn;